import React from 'react';

function SkeletonBlock({ width = '100%', height = '16px', borderRadius = '6px', style = {} }) {
  return (
    <div
      className="skeleton"
      style={{ width, height, borderRadius, ...style }}
    />
  );
}

function StatCardSkeleton() {
  return (
    <div style={{
      background: 'linear-gradient(160deg, #161731 0%, #12132a 55%, #0f1024 100%)',
      border: '1px solid rgba(255,255,255,0.07)',
      borderRadius: '12px',
      padding: '20px',
      display: 'flex',
      alignItems: 'flex-start',
      gap: '16px',
    }}>
      <SkeletonBlock width="44px" height="44px" borderRadius="10px" />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <SkeletonBlock width="60%" height="10px" />
        <SkeletonBlock width="40%" height="24px" />
        <SkeletonBlock width="50%" height="10px" />
      </div>
    </div>
  );
}

function TableRowsSkeleton({ rows = 5, cols = 4 }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1px' }}>
      {Array.from({ length: rows }).map((_, i) => (
        <div
          key={i}
          style={{
            display: 'grid',
            gridTemplateColumns: `repeat(${cols}, 1fr)`,
            gap: '16px',
            padding: '12px 16px',
            borderBottom: '1px solid rgba(255,255,255,0.04)',
          }}
        >
          {Array.from({ length: cols }).map((_, j) => (
            <SkeletonBlock
              key={j}
              width={j === 0 ? '70%' : j === cols - 1 ? '40%' : '80%'}
              height="14px"
            />
          ))}
        </div>
      ))}
    </div>
  );
}

function CardSkeleton({ height = '120px' }) {
  return (
    <div style={{
      background: 'linear-gradient(160deg, #161731 0%, #12132a 55%, #0f1024 100%)',
      border: '1px solid rgba(255,255,255,0.07)',
      borderRadius: '12px',
      padding: '20px',
      height,
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
    }}>
      <SkeletonBlock width="40%" height="12px" />
      <SkeletonBlock width="70%" height="20px" />
      <SkeletonBlock width="55%" height="12px" />
    </div>
  );
}

const Skeleton = {
  Block: SkeletonBlock,
  StatCard: StatCardSkeleton,
  TableRows: TableRowsSkeleton,
  Card: CardSkeleton,
};

export default Skeleton;
